import styled from "styled-components/native";
import { lineHeights } from "~/styles/theme";
import { Text8 } from "../text";

export const HeaderTitle = styled(Text8)`
  font-family: MontserratMedium;
  line-height: ${lineHeights.lh6};
  letter-spacing: -0.5px;
`;
